import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteTransport = async (ID) => {
  try {
    const TransportDocument = doc(db, "Transports", ID);

    await updateDoc(TransportDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteTransport;
